import { createSlice } from '@reduxjs/toolkit';
import { DealsNoteObject } from '../../params/redux/pipeline';
import { NoteState } from '../../params/redux/note';
import { addDealNoteThunk, deleteDealNoteThunk, editDealNoteThunk, getDealsNotesThunk } from '../thunks/note';

// Initial state with default values for authentication and user info
const initialState: NoteState = {
    // Auth token stored after successful login
    notes: [],
    selectedNote: null,
    loaders: {
        isCreating: false,
        isUpdating: false,
        isDeleting: false,
        isLoading: false,
        isSearching: false,
        isInserting: false
    }
};

// Slice for app-related states and actions
const noteSlice = createSlice({
    // Slice name
    name: 'note',
    // inital state for the slice
    initialState,
    reducers: {
        settingSelectedNote: (state, action) => {
            state.selectedNote = action.payload;
        },
        // Resets loading states related to app actions
        resettingNoteLoader: (state) => {
            state.loaders = initialState.loaders;
        },
        // Resets all app data to the initial state
        resettingNoteData: () => initialState
    },
    extraReducers: (builder) => {
        builder
            .addCase(getDealsNotesThunk.pending, (state) => {
                state.loaders.isLoading = true;
            })
            .addCase(getDealsNotesThunk.fulfilled, (state, action) => {
                state.notes = action.payload as DealsNoteObject[];
            })
            .addCase(getDealsNotesThunk.rejected, (state) => {
                state.notes = [];
                state.selectedNote = null;
            });
        builder
            .addCase(addDealNoteThunk.pending, (state) => {
                state.loaders.isCreating = true;
            })
            .addCase(addDealNoteThunk.fulfilled, () => {
                //
            })
            .addCase(addDealNoteThunk.rejected, () => {
                //
            });
        builder
            .addCase(editDealNoteThunk.pending, (state) => {
                state.loaders.isUpdating = true;
            })
            .addCase(editDealNoteThunk.fulfilled, () => {
                //
            })
            .addCase(editDealNoteThunk.rejected, () => {
                //
            });
        builder
            .addCase(deleteDealNoteThunk.pending, (state) => {
                state.loaders.isDeleting = true;
            })
            .addCase(deleteDealNoteThunk.fulfilled, () => {
                //
            })
            .addCase(deleteDealNoteThunk.rejected, () => {
                //
            });
    }
});

// Exporting actions for updating app state
export const {
    settingSelectedNote,
    resettingNoteData,
    resettingNoteLoader
} = noteSlice.actions;

// Exporting the reducer to be used in the store
export default noteSlice.reducer;
